import { render, staticRenderFns } from "./FormCommittee.vue?vue&type=template&id=50fc0136&scoped=true"
import script from "./FormCommittee.vue?vue&type=script&lang=js"
export * from "./FormCommittee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc0136",
  null
  
)

export default component.exports